import AmazonVA from "../assets/coursebanners/Amazon Virtual Assistant.jpg";
import FullStackDM from "../assets/coursebanners/Full Stack Digital Marketing & AI.jpg";
import ShopifyDaraz from "../assets/coursebanners/Shopify & Daraz Business.jpg";
import FullStackGD from "../assets/coursebanners/Full Stack Graphic Designing & AI.jpg";
import UIUXDesign from "../assets/coursebanners/UIUX Designing for Web & App.jpg";
import WordPressDev from "../assets/coursebanners/WordPress Website Development.jpg";
import ReactNodeJS from "../assets/coursebanners/React & Node js Full Stack Development.jpg";
import MERNStack from "../assets/coursebanners/MERN Stack Web Development.jpg";
import PHPLaravel from "../assets/coursebanners/PHP Laravel Web Development.jpg";
import PythonProgramming from "../assets/coursebanners/Python Programming for Everyone.jpg";
import VideoEditing from "../assets/coursebanners/Video Editing & Animation.jpg";
import AI from "../assets/coursebanners/Artificial Intelligence (AI).jpg";
import MLDataScience from "../assets/coursebanners/Machine Learning & Data Science.jpg";
import CyberSecurity from "../assets/coursebanners/National Cyber Security.jpg";
import IELTS from "../assets/coursebanners/IELTS Preparation.jpg";
import Freelancing from "../assets/coursebanners/Freelancing Program.jpg";
import TextileDesign from "../assets/coursebanners/Textile Designing.jpg";
import DigitalEmbroidery from "../assets/coursebanners/Digital Embroidery.jpg";
import CGIAds from "../assets/coursebanners/CGI Ads.jpg";
import FlutterDev from "../assets/coursebanners/Flutter App Development.jpg";
import ForexTrading from "../assets/coursebanners/Forex Trading.jpg";
import YouTubeMonetization from "../assets/coursebanners/YouTube Monetization.jpg";
import PenetrationTesting from "../assets/coursebanners/Penetration Testing.jpg";
import AdvancedGoogleAds from "../assets/coursebanners/Advanced Google Ads.jpg";
import SEO from "../assets/coursebanners/SEO.jpg";

export const courseContentData = {
  "Full Stack Graphic Designing & AI": {
    category: "Graphic Design & Creative Arts",
    description:
      "Discover a comprehensive graphic design program that combines traditional design principles with cutting-edge AI tools. Learn to create stunning visuals for digital and print media.",
    duration: "4 Months",
    level: "Beginner to Advanced",
    image: FullStackGD,
    aboutCourse: `The Full Stack Graphic Designing & AI Course is a complete step-by-step training program designed to teach you professional graphic designing from scratch. Whether you're creating social media posts, brand logos, marketing materials, or personal projects, this course equips you with the creative and technical skills needed to succeed in today's design industry.

You can learn at your own pace, anytime and anywhere. It covers all essential graphic design tools and techniques, using industry-leading software like Adobe Photoshop and Adobe Illustrator.

By the end of the course, you'll be able to confidently create professional designs, build your own portfolio, and even start earning through freelancing platforms.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior design experience required",
      "Creative mindset and willingness to learn",
      "Adobe Creative Suite (trial version available)",
    ],
    materialIncludes: [
      "Complete Adobe Photoshop & Illustrator training",
      "AI-powered design tools and techniques",
      "Portfolio development guidance",
      "Freelancing platform setup tutorials",
      "Industry-standard design templates",
      "One-on-one project feedback",
    ],
    whoCanJoin: [
      "Students: College and university students who want to learn a practical and creative skill",
      "Beginners: Anyone who wants to start learning graphic design without any prior experience",
      "Freelancers: People who want to offer design services on freelance platforms like Fiverr, Upwork, or Freelancer",
      "Small Business Owners: Entrepreneurs who want to design their own marketing materials, social media content, and brand logos",
      "Social Media Managers & Marketers: Those managing brand pages and creating advertising content",
      "Creative Enthusiasts: Anyone who loves creativity and wants to turn their hobby into a professional skill",
    ],
    whatWillYouLearn: [
      "Graphic Design Basics: What is graphic design, elements and principles of design",
      "Color theory and typography basics",
      "Layouts, balance, and visual composition",
      "Adobe Photoshop mastery for photo editing and manipulation",
      "Adobe Illustrator for vector graphics and logo design",
      "AI-powered design tools and automation techniques",
      "Social media design and marketing materials",
      "Brand identity and logo design principles",
      "Print design and production techniques",
      "Portfolio creation and freelancing setup",
    ],
  },
  "Full Stack Digital Marketing & AI": {
    category: "Digital Marketing",
    description:
      "Master the complete digital marketing landscape with AI-powered strategies. Learn to grow businesses online through comprehensive marketing techniques.",
    duration: "4 Months",
    level: "Beginner to Advanced",
    image: FullStackDM,
    aboutCourse: `The Full Stack Digital Marketing & AI Course is designed to give you complete knowledge of how businesses grow online. This course covers everything from basic digital marketing concepts to advanced strategies. Whether your goal is to market your own business, work for a company, or offer your services as a freelancer, this course will prepare you for success in the digital world.

You can learn at your own pace, whenever and wherever you want. It provides step-by-step guidance on how to run marketing campaigns, increase website traffic, build brand awareness, and generate leads using the latest digital platforms and tools.

By the end of the course, you'll be able to confidently plan and manage complete digital marketing strategies across various online channels.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior marketing knowledge required",
      "Interest in digital platforms and social media",
      "Willingness to learn new tools and technologies",
    ],
    materialIncludes: [
      "Complete digital marketing strategy guide",
      "Social media marketing tools and templates",
      "SEO and Google Ads training materials",
      "Email marketing templates and automation guides",
      "Analytics and reporting tools access",
      "Portfolio development resources",
    ],
    whoCanJoin: [
      "Students: College or university students looking to learn a high-demand digital skill",
      "Beginners: Anyone with no prior marketing knowledge who wants to start a career in digital marketing",
      "Freelancers: People who want to offer digital marketing services on Fiverr, Upwork, or Freelancer",
      "Small Business Owners: Entrepreneurs who want to market their own products or services online",
      "Marketing Professionals: Those who want to update and expand their digital marketing skills",
      "Social Media Managers & Content Creators: Who want to run better campaigns and grow social media pages",
    ],
    whatWillYouLearn: [
      "Digital Marketing Foundations: Introduction to digital marketing and how it works",
      "Building marketing strategies and understanding customer journeys",
      "Identifying target audiences and analyzing competitors",
      "Social Media Marketing (Facebook, Instagram, LinkedIn)",
      "Search Engine Optimization (SEO) to rank websites on Google",
      "Google Ads and Facebook Ads (paid advertising campaigns)",
      "Email Marketing for customer engagement and lead generation",
      "Content Marketing and Blogging for organic growth",
      "Keyword research and search engine optimization (SEO) basics",
      "Tracking performance with Google Analytics",
    ],
  },
  "Amazon Virtual Assistant": {
    category: "E-commerce & Virtual Assistance",
    description:
      "Learn to support Amazon sellers and build a successful career as a virtual assistant in the booming e-commerce industry.",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    image: AmazonVA,
    aboutCourse: `The Amazon Virtual Assistant Course is designed to help you build the skills needed to support Amazon sellers and businesses. Virtual assistants are in high demand worldwide, especially for managing Amazon accounts, product listings, order processing, and customer service.

Through this course, you'll learn how to assist Amazon sellers from A to Z — from product research and store management to order handling and customer communication. You'll also learn the basics of how to start freelancing as an Amazon Virtual Assistant on platforms like Fiverr, Upwork, and Freelancer.

This is a self-paced, recorded video course, making it easy for you to learn anytime, anywhere — at your own convenience.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior Amazon experience required",
      "Good communication skills",
      "Attention to detail and organizational skills",
    ],
    materialIncludes: [
      "Complete Amazon Seller Central training",
      "Product research tools and techniques",
      "Customer service templates and guidelines",
      "Freelancing platform setup guides",
      "Practice accounts and real-world scenarios",
      "Portfolio development resources",
    ],
    whoCanJoin: [
      "Students: Looking to learn an in-demand skill for freelancing",
      "Beginners: Who have no experience but want to work as Amazon Virtual Assistants",
      "Freelancers: Wanting to offer Amazon VA services on Fiverr, Upwork, and other freelance platforms",
      "Housewives: Looking for remote income opportunities",
      "Job Seekers: Interested in starting a career in Amazon E-Commerce support",
      "Anyone who wants to start freelancing without investing in stock or creating their own Amazon store",
    ],
    whatWillYouLearn: [
      "Introduction to Amazon & VA Role: What is an Amazon Virtual Assistant",
      "How the Amazon business model works (Private Label, Wholesale, FBA)",
      "Product Research (Tools & Techniques)",
      "Product Listing Creation & Optimization",
      "Order Management & Shipment Creation",
      "Inventory Management",
      "Amazon Policies and Guidelines",
      "Keyword Research for Product Listings",
      "Pricing Strategies",
      "Managing Customer Messages & Feedback",
    ],
  },
  "Shopify & Daraz Business": {
    category: "E-commerce & Business",
    description:
      "Master online selling with Shopify and Daraz. Learn to create and manage successful online stores for global and local markets.",
    duration: "4 Months",
    level: "Beginner to Intermediate",
    image: ShopifyDaraz,
    aboutCourse: `Start your journey in e-commerce and learn how to set up and run your own online store with Shopify and Daraz. This course is designed to teach you how to build a professional online business, manage products, handle orders, and generate sales through Pakistan's leading marketplace Daraz and the global e-commerce platform Shopify.

Through this course, you will learn practical skills to start your own online business or work as an e-commerce virtual assistant. No prior business experience or technical skills are required — we start from the basics and progress to advanced store management.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior business experience required",
      "Interest in online selling and e-commerce",
      "Willingness to learn new platforms and tools",
    ],
    materialIncludes: [
      "Complete Shopify store setup guide",
      "Daraz Seller Center training materials",
      "Product research and sourcing guides",
      "Marketing and promotion strategies",
      "Business templates and resources",
      "Freelancing setup guides",
    ],
    whoCanJoin: [
      "Students: Who want to learn e-commerce and earn online",
      "Beginners: Who have no experience in online selling",
      "Entrepreneurs: Who want to launch their own online store",
      "Freelancers: Offering Daraz and Shopify store management services on Fiverr and Upwork",
      "Small Business Owners: Looking to sell their products online in Pakistan and globally",
      "Anyone interested in starting a home-based or online business",
    ],
    whatWillYouLearn: [
      "Introduction to Daraz Seller Center",
      "How to create and verify your Daraz seller account",
      "Product listing & pricing strategies",
      "Order processing and shipment management",
      "What is Shopify and how it works",
      "Creating your Shopify account and setting up an online store",
      "Adding products, collections, and categories",
      "Choosing the right themes and customizing your store",
      "Setting up payment gateways and shipping options",
      "Finding trending products to sell",
    ],
  },
  "National Cyber Security": {
    category: "Cybersecurity & IT Security",
    description:
      "Learn essential cybersecurity skills to protect systems, networks, and data from cyber threats in today's digital world.",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    image: CyberSecurity,
    aboutCourse: `Our National Cyber Security Course is designed to provide you with essential knowledge and practical skills to protect systems, networks, and data from cyber threats. In today's digital world, cyber security is one of the most in-demand fields, and this course helps you build a strong foundation to start a career in the cybersecurity industry.

In this course, you can learn anytime, anywhere, at your own pace. From understanding how hackers operate to learning how to defend against attacks, this course will help you develop the practical skills needed for personal protection and professional opportunities.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior technical knowledge required",
      "Interest in cybersecurity and IT security",
      "Willingness to learn security concepts",
    ],
    materialIncludes: [
      "Complete cybersecurity fundamentals guide",
      "Security tools and software access",
      "Practice environments and labs",
      "Ethical hacking basics training",
      "Security assessment templates",
      "Career guidance and certification prep",
    ],
    whoCanJoin: [
      "Students: Who want to explore career opportunities in the cybersecurity field",
      "Beginners: No prior technical knowledge required — we start from the basics",
      "IT Professionals: Who want to strengthen their network and data security skills",
      "Freelancers: Who want to offer cybersecurity assessments and services",
      "Business Owners: Who want to protect their digital assets and customer data",
      "Anyone interested in understanding how cyber-attacks work and how to prevent them",
    ],
    whatWillYouLearn: [
      "What is cyber security and why is it important",
      "Common cyber threats (malware, phishing, ransomware, etc.)",
      "Understanding hackers, cybercrime, and ethical hacking basics",
      "Securing personal and business networks",
      "Basics of firewalls, antivirus, and encryption",
      "Protecting Wi-Fi networks, mobile devices, and cloud storage",
      "Identifying phishing emails and fake websites",
      "Creating strong passwords and managing them securely",
      "Setting up two-factor authentication (2FA)",
      "Introduction to ethical hacking & penetration testing",
    ],
  },
  "UI/UX Designing for Web & App": {
    category: "Design & User Experience",
    description:
      "Master the art of creating engaging and user-friendly digital experiences for web and mobile applications.",
    duration: "4 Months",
    level: "Beginner to Advanced",
    image: UIUXDesign,
    aboutCourse: `Our UI/UX Designing Course is carefully designed to help you master the art and science of creating engaging and user-friendly digital experiences. Whether you want to design mobile apps, websites, or software interfaces, this course covers everything from the fundamentals to advanced design techniques.

This course, allowing you to learn flexibly at your own pace. You will learn to use industry-leading tools and methodologies to build intuitive and beautiful user interfaces (UI) and seamless user experiences (UX).

By completing this course, you will be ready to design user-centric digital products that solve real-world problems and stand out in the market.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior design experience needed",
      "Creative mindset and problem-solving skills",
      "Interest in user-centered design",
    ],
    materialIncludes: [
      "Complete UI/UX design tools training",
      "Design system and component libraries",
      "User research and testing methodologies",
      "Prototyping and wireframing tools",
      "Portfolio development guidance",
      "Industry best practices and trends",
    ],
    whoCanJoin: [
      "Students: Interested in building a career in digital design and development",
      "Beginners: No prior design experience needed — we start from the basics",
      "Graphic Designers: Who want to upgrade their skills into UI/UX design",
      "Web Developers: Wanting to understand design principles to build better user interfaces",
      "Freelancers: Looking to offer UI/UX design services on platforms like Fiverr and Upwork",
      "Product Managers & Entrepreneurs: Who want to create user-friendly products and apps",
    ],
    whatWillYouLearn: [
      "UI/UX Design Fundamentals and principles",
      "User research and persona development",
      "Information architecture and wireframing",
      "Visual design and prototyping",
      "User testing and usability evaluation",
      "Design systems and component libraries",
      "Mobile app and responsive web design",
      "Design tools like Figma, Sketch, and Adobe XD",
      "Portfolio creation and presentation skills",
      "Freelancing and career guidance",
    ],
  },
  "React & Node.js Full Stack Development": {
    category: "Web Development",
    description:
      "Master full-stack web development with React frontend and Node.js backend to build modern, scalable web applications.",
    duration: "5 Months",
    level: "Intermediate to Advanced",
    image: ReactNodeJS,
    aboutCourse: `Learn to build complete web applications using React for the frontend and Node.js for the backend. This comprehensive course covers everything from creating interactive user interfaces to building robust server-side applications and APIs.

You can learn at your own pace, gaining practical skills to create dynamic, scalable, and responsive web apps. This course is designed to prepare you for careers as a full stack developer or freelancer in the web development field.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "Basic understanding of HTML, CSS, and JavaScript",
      "Interest in web development and programming",
      "Willingness to learn modern web technologies",
    ],
    materialIncludes: [
      "Complete React and Node.js training",
      "Development environment setup guides",
      "Project-based learning materials",
      "API development and integration guides",
      "Deployment and hosting tutorials",
      "Portfolio development resources",
    ],
    whoCanJoin: [
      "Students: Looking to build professional web development skills",
      "Beginners: No prior experience required; start from scratch",
      "Frontend Developers: Want to learn backend development with Node.js",
      "Backend Developers: Interested in learning modern frontend frameworks like React",
      "Freelancers: Looking to offer full stack development services",
      "Professionals: Seeking to upskill and work on cutting-edge web technologies",
    ],
    whatWillYouLearn: [
      "React fundamentals: Components, JSX, Props, and State",
      "React Hooks and functional components",
      "Building interactive UI with React Router and forms",
      "State management using Context API or Redux",
      "Setting up Node.js environment",
      "Building RESTful APIs with Express.js",
      "Working with databases (MongoDB or SQL)",
      "Authentication and authorization (JWT, OAuth)",
      "Connecting React frontend with Node.js backend",
      "Deploying full stack applications on cloud platforms",
    ],
  },
  "MERN Stack Web Development": {
    category: "Web Development",
    description:
      "Master the MERN stack (MongoDB, Express.js, React.js, Node.js) to build powerful full-stack web applications.",
    duration: "5 Months",
    level: "Intermediate to Advanced",
    image: MERNStack,
    aboutCourse: `The MERN Stack Web Development Course offers complete training in building powerful web applications using the popular MERN stack — MongoDB, Express.js, React.js, and Node.js. This course takes you through the entire process of developing full-stack JavaScript applications, from designing the frontend interface to building backend APIs and managing databases.

In this course, you can learn at your own pace, gaining practical skills to create dynamic, scalable, and responsive web apps. This course is designed to prepare you for careers as a MERN stack developer or freelancer in the web development field.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "Basic understanding of HTML, CSS, and JavaScript",
      "Interest in full-stack development",
      "Willingness to learn modern JavaScript frameworks",
    ],
    materialIncludes: [
      "Complete MERN stack training",
      "MongoDB database setup and management",
      "Express.js API development guides",
      "React.js frontend development materials",
      "Node.js backend development tutorials",
      "Project-based learning resources",
    ],
    whoCanJoin: [
      "Students: Looking to build professional web development skills",
      "Beginners: No prior experience required; start from scratch",
      "Frontend Developers: Want to learn backend development with Node.js and MongoDB",
      "Backend Developers: Interested in mastering React for frontend development",
      "Freelancers: Wanting to offer full-stack development services",
      "IT Professionals: Seeking to upgrade their skills and work on modern web technologies",
    ],
    whatWillYouLearn: [
      "Introduction to NoSQL databases",
      "Creating and managing collections and documents",
      "Querying, updating, and deleting data",
      "Setting up the server environment",
      "Building RESTful APIs",
      "Middleware and routing",
      "React fundamentals: Components, state, and props",
      "React hooks and functional components",
      "Managing routes and navigation",
      "Integrating React frontend with Express backend",
    ],
  },
  "PHP Laravel Web Development": {
    category: "Web Development",
    description:
      "Master PHP and Laravel framework to build robust, secure, and scalable web applications with modern development practices.",
    duration: "4 Months",
    level: "Beginner to Advanced",
    image: PHPLaravel,
    aboutCourse: `The PHP Laravel Web Development Course is designed to teach you how to build robust, secure, and scalable web applications using PHP and the powerful Laravel framework. Laravel is one of the most popular PHP frameworks known for its elegant syntax and rich features that simplify web development.

This course allow you to learn at your own pace, mastering everything from basic PHP programming to advanced Laravel concepts. Whether you want to build custom websites, dynamic web apps, or backend APIs, this course provides hands-on training to make you a professional Laravel developer.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior programming experience required",
      "Interest in web development and PHP",
      "Willingness to learn modern development practices",
    ],
    materialIncludes: [
      "Complete PHP and Laravel training",
      "Development environment setup guides",
      "Database management tutorials",
      "Project-based learning materials",
      "Deployment and hosting guides",
      "Best practices and security guidelines",
    ],
    whoCanJoin: [
      "Students: Interested in web development and PHP programming",
      "Beginners: No prior programming experience required; start from basics",
      "PHP Developers: Who want to learn Laravel to enhance their skills",
      "Web Developers: Seeking to build scalable and maintainable web applications",
      "Freelancers: Wanting to offer PHP and Laravel development services",
      "Entrepreneurs: Looking to build custom web applications for their business",
    ],
    whatWillYouLearn: [
      "Basics of PHP programming",
      "Variables, data types, control structures, and functions",
      "Working with forms and user input",
      "Installing and configuring Laravel",
      "Understanding MVC architecture",
      "Routing and middleware",
      "Working with databases using Laravel's Eloquent ORM",
      "CRUD operations (Create, Read, Update, Delete)",
      "User authentication and authorization",
      "Building RESTful APIs development with Laravel",
    ],
  },
  "Python Programming for Everyone": {
    category: "Programming & Development",
    description:
      "Learn Python programming from scratch with practical projects and real-world applications for beginners and professionals.",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    image: PythonProgramming,
    aboutCourse: `The Python Programming for Everyone Course is designed to make programming simple and accessible for learners of all backgrounds. Whether you're a student, professional, or hobbyist, this course will guide you step-by-step through the basics of Python — one of the world's most popular and versatile programming languages.

This course allow you to learn at your own pace and build a strong foundation in programming concepts. You'll learn practical skills to write clean, efficient code and solve real-world problems using Python.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior programming experience required",
      "Interest in learning to code",
      "Willingness to practice and solve problems",
    ],
    materialIncludes: [
      "Complete Python programming guide",
      "Development environment setup",
      "Practice exercises and projects",
      "Real-world application examples",
      "Problem-solving techniques",
      "Career guidance and next steps",
    ],
    whoCanJoin: [
      "Absolute Beginners: No prior coding or technical experience needed",
      "Students: Looking to build programming skills for academics or future careers",
      "Professionals: Who want to automate tasks or enhance their technical abilities",
      "Freelancers: Planning to offer Python programming services",
      "Anyone Curious About Coding: Whether young or old, this course welcomes everyone",
    ],
    whatWillYouLearn: [
      "Installing Python and setting up your programming environment",
      "Understanding variables, data types, and operators",
      "Control structures: if statements, loops, and functions",
      "Working with lists, dictionaries, and other data structures",
      "File handling and data processing",
      "Object-oriented programming basics",
      "Working with external libraries and modules",
      "Building simple applications and games",
      "Web scraping and automation basics",
      "Introduction to data analysis with Python",
    ],
  },
  "Video Editing & Animation": {
    category: "Media & Creative Arts",
    description:
      "Master video editing and animation techniques to create stunning visual content for digital media and marketing.",
    duration: "4 Months",
    level: "Beginner to Advanced",
    image: VideoEditing,
    aboutCourse: `Unlock your creative potential with our Video Editing & Animation Course! This course is designed to teach you how to craft stunning videos and animations using industry-standard software and techniques. Whether you want to create promotional videos, explainer animations, social media content, or cinematic edits, this course will guide you through every step of the process.

In this course, you can learn at your own pace and practice hands-on projects that build your skills from basic editing to advanced animation. Gain the expertise to bring stories to life visually and boost your career in digital media.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior editing or animation experience needed",
      "Creative mindset and visual storytelling skills",
      "Interest in digital media and video production",
    ],
    materialIncludes: [
      "Complete video editing software training",
      "Animation tools and techniques",
      "Project files and templates",
      "Industry-standard software access",
      "Portfolio development resources",
      "Freelancing and career guidance",
    ],
    whoCanJoin: [
      "Students: Interested in media, film, or digital content creation",
      "Beginners: No prior editing or animation experience needed",
      "Content Creators & YouTubers: Wanting to enhance video quality and engagement",
      "Freelancers: Looking to offer video editing and animation services",
      "Marketing Professionals: Who want to create eye-catching promotional videos",
      "Anyone passionate about storytelling through video and animation",
    ],
    whatWillYouLearn: [
      "Understanding video formats and timelines",
      "Cutting, trimming, and arranging clips",
      "Adding transitions and effects",
      "Color correction and grading",
      "Audio editing and mixing",
      "Principles of animation",
      "Creating 2D animations",
      "Using keyframes and easing",
      "Adobe Premiere Pro and After Effects mastery",
      "Making explainer videos and intros",
    ],
  },
  "Artificial Intelligence (AI)": {
    category: "Technology & AI",
    description:
      "Explore the future of technology with comprehensive AI training covering machine learning, neural networks, and intelligent systems.",
    duration: "4 Months",
    level: "Beginner to Intermediate",
    image: AI,
    aboutCourse: `Step into the future with our comprehensive Artificial Intelligence (AI) Course, designed to introduce you to the concepts, techniques, and applications of AI. Learn how machines can simulate human intelligence to solve complex problems, automate tasks, and make smart decisions.

In this course you can access anytime, allowing you to learn at your own pace. From fundamental AI principles to hands-on projects, gain the knowledge and skills needed to start your journey in one of the most exciting and rapidly evolving fields in technology.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior programming or AI knowledge required",
      "Interest in emerging technologies",
      "Willingness to learn mathematical concepts",
    ],
    materialIncludes: [
      "Complete AI fundamentals training",
      "Python programming for AI applications",
      "Machine learning libraries and tools",
      "Hands-on AI projects",
      "Industry case studies and applications",
      "Career guidance and certification prep",
    ],
    whoCanJoin: [
      "Students: Interested in computer science, data science, or emerging technologies",
      "Beginners: No prior programming or AI knowledge required",
      "Professionals: Looking to upskill in AI and machine learning",
      "Developers: Seeking to incorporate AI into their applications",
      "Business Leaders: Wanting to understand AI's impact and opportunities",
      "Anyone passionate about learning the future of technology",
    ],
    whatWillYouLearn: [
      "Introduction to Artificial Intelligence and its history",
      "Types of AI: Narrow AI, General AI, and Super AI",
      "Key concepts: Machine Learning, Deep Learning, and Neural Networks",
      "Basics of Python for AI applications",
      "Using libraries like NumPy, Pandas, and Scikit-learn",
      "Supervised and unsupervised learning",
      "Classification, regression, and clustering algorithms",
      "Understanding neural networks and architectures",
      "Natural Language Processing (NLP) basics",
      "Computer vision and image recognition",
    ],
  },
  "Machine Learning & Data Science": {
    category: "Data Science & Analytics",
    description:
      "Master data science and machine learning to extract insights, build predictive models, and make data-driven decisions.",
    duration: "5 Months",
    level: "Intermediate to Advanced",
    image: MLDataScience,
    aboutCourse: `Dive into the powerful world of data with our Machine Learning & Data Science Course designed to teach you how to extract insights, build predictive models, and make data-driven decisions. Learn the essential concepts and tools used by data scientists and machine learning engineers to analyze complex datasets and create intelligent algorithms.

This course allow you to learn at your own pace. Gain hands-on experience with real-world projects and popular data science libraries and tools, preparing you for a career in one of today's most in-demand fields.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "Basic understanding of mathematics and statistics",
      "Interest in data analysis and machine learning",
      "Willingness to learn programming concepts",
    ],
    materialIncludes: [
      "Complete data science training",
      "Python programming for data science",
      "Machine learning libraries and tools",
      "Real-world datasets and projects",
      "Statistical analysis tools",
      "Portfolio development resources",
    ],
    whoCanJoin: [
      "Students: Interested in data analysis, AI, or computer science",
      "Beginners: No prior programming or data science knowledge needed",
      "Professionals: Looking to upskill in data science and machine learning",
      "Developers: Wanting to add data science capabilities to their skillset",
      "Business Analysts: Seeking to leverage data for strategic decisions",
      "Anyone passionate about turning data into actionable insights",
    ],
    whatWillYouLearn: [
      "Understanding data types and data wrangling",
      "Exploratory Data Analysis (EDA) and visualization",
      "Using Python libraries: Pandas, NumPy, Matplotlib, Seaborn",
      "Supervised vs. unsupervised learning",
      "Key algorithms: Linear Regression, Decision Trees, K-Means Clustering",
      "Model training, testing, and evaluation metrics",
      "Ensemble methods and Random Forest",
      "Support Vector Machines (SVM)",
      "Building predictive models with real datasets",
      "Jupyter Notebook and Python environment setup",
    ],
  },
  "IELTS Preparation": {
    category: "Language & Education",
    description:
      "Prepare for IELTS success with comprehensive training in all four components: Listening, Reading, Writing, and Speaking.",
    duration: "3 Months",
    level: "Beginner to Advanced",
    image: IELTS,
    aboutCourse: `Prepare to achieve your desired IELTS score with our comprehensive IELTS Preparation Course. This course is designed to help you master all four components of the IELTS exam—Listening, Reading, Writing, and Speaking. Whether you aim to study abroad, work internationally, or migrate, this course provides proven strategies, practice materials, and expert guidance to boost your confidence and performance.

In this course, you can learn at your own pace, revisiting lessons as needed to improve your skills and exam readiness.`,
    requirements: [
      "Basic English language skills",
      "A laptop or desktop with internet access",
      "Commitment to regular practice",
      "Interest in improving English proficiency",
      "Goal-oriented mindset",
    ],
    materialIncludes: [
      "Complete IELTS preparation materials",
      "Practice tests and sample questions",
      "Audio materials for listening practice",
      "Writing templates and examples",
      "Speaking practice resources",
      "Exam strategies and tips",
    ],
    whoCanJoin: [
      "Students: Planning to study in English-speaking countries",
      "Professionals: Seeking work opportunities abroad",
      "Migrants: Preparing for immigration requirements",
      "Beginners and Intermediate English Speakers: Wanting structured IELTS preparation",
      "Anyone aiming to improve English language proficiency and IELTS scores",
    ],
    whatWillYouLearn: [
      "Understanding different question types",
      "Strategies for active listening and note-taking",
      "Practice with diverse audio clips and accents",
      "Techniques for skimming and scanning",
      "Managing time effectively",
      "Structuring Task 1 (graphs, charts) and Task 2 (essay)",
      "Developing coherence and cohesion",
      "Answering common topics confidently",
      "Pronunciation and fluency improvement",
      "Time management techniques",
    ],
  },
  "Freelancing Program": {
    category: "Career & Business",
    description:
      "Master the art of freelancing with comprehensive training in client acquisition, project management, and building a successful freelance business.",
    duration: "2 Months",
    level: "Beginner to Intermediate",
    image: Freelancing,
    aboutCourse: `Kickstart your freelancing career with our comprehensive Freelancing Program Course designed to equip you with the skills, strategies, and mindset needed to succeed in the competitive freelance marketplace. Learn how to find clients, manage projects, price your services, and build a sustainable freelance business — all through practical, you can access anytime.

Whether you want to work independently, earn extra income, or build a full-time freelance career, this course guides you through the essentials of freelancing across various industries including design, writing, programming, marketing, and more.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "A skill or service to offer",
      "Good communication skills",
      "Self-motivation and discipline",
    ],
    materialIncludes: [
      "Complete freelancing strategy guide",
      "Platform setup tutorials",
      "Client communication templates",
      "Portfolio development resources",
      "Pricing and negotiation guides",
      "Business management tools",
    ],
    whoCanJoin: [
      "Students: Looking to earn while learning and build professional experience",
      "Beginners: New to freelancing and unsure where to start",
      "Professionals: Wanting to switch to freelance or supplement income",
      "Creative & Tech Workers: Designers, developers, writers, marketers, etc.",
      "Entrepreneurs: Interested in building a personal brand and client base",
      "Anyone eager to become their own boss and work on flexible terms",
    ],
    whatWillYouLearn: [
      "Understanding the freelance ecosystem and platforms",
      "Identifying your skills and market demand",
      "Setting up profiles on platforms like Upwork, Fiverr, Freelancer",
      "Crafting compelling proposals and pitches",
      "Building long-term client relationships",
      "Planning and managing freelance projects efficiently",
      "Setting competitive yet profitable rates",
      "Creating a standout portfolio",
      "Personal branding and marketing yourself",
      "Expanding your freelance business",
    ],
  },
  // Default WordPress course
  "WordPress Website Development": {
    category: "Software Development",
    description:
      "Discover a wide range of skill-building programs designed to boost your career prospects. Find the perfect course to help you shine!",
    duration: "3 Months",
    level: "Intermediate",
    image: WordPressDev,
    aboutCourse: `This course is perfect for beginners who want to learn how to create professional websites using WordPress, the world's most popular content management system. It covers everything from installation to creating dynamic, fully functional websites. By the end of the course, students will have the skills to build, manage, and customize WordPress sites for various purposes.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior knowledge of WordPress or web development is needed",
    ],
    materialIncludes: [
      "Step-by-step course guide",
      "Resource links for free and premium themes/plugins",
      "Sample website project for practice",
    ],
    whoCanJoin: [
      "Beginners with no coding experience",
      "Small business owners wanting to create their own websites",
      "Freelancers looking to offer WordPress services",
      "Students interested in web development",
    ],
    whatWillYouLearn: [
      "WordPress installation and setup",
      "Theme customization and development",
      "Plugin management and development",
      "Content management and SEO optimization",
      "E-commerce integration with WooCommerce",
    ],
  },
  "Textile Designing": {
    category: "Fashion & Textile Design",
    description:
      "Discover the vibrant world of fabric and patterns with comprehensive textile design training for fashion, interiors, and creative industries.",
    duration: "4 Months",
    level: "Beginner to Advanced",
    image: TextileDesign,
    aboutCourse: `Discover the vibrant world of fabric and patterns with our Textile Designing Course. This course is crafted to teach you the fundamentals and advanced techniques of designing textiles for fashion, interiors, and other creative industries. Learn about fabric types, surface ornamentation, printing methods, and color theory to bring your creative visions to life.

This course provides flexible learning at your own pace with practical assignments that build your skills in both traditional and digital textile design.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior design experience required",
      "Creative mindset and passion for colors and patterns",
      "Interest in fashion and textile arts",
    ],
    materialIncludes: [
      "Complete textile design fundamentals",
      "Digital design software training",
      "Traditional and digital printing techniques",
      "Color theory and pattern development",
      "Portfolio development guidance",
      "Industry insights and career guidance",
    ],
    whoCanJoin: [
      "Beginners: No prior experience needed; perfect for creative enthusiasts",
      "Fashion Designers & Tailors: Looking to enhance their design skills",
      "Artists & Illustrators: Interested in fabric design and pattern making",
      "Entrepreneurs: Wanting to start a textile design or printing business",
      "Students: Pursuing careers in fashion, interior design, or visual arts",
      "Anyone passionate about colors, patterns, and fabric art",
    ],
    whatWillYouLearn: [
      "Textile Design Basics: Introduction to textiles and fabric types",
      "Understanding yarns, weaves, and textures",
      "Design Principles & Color Theory: Elements and principles of design applied to textiles",
      "Color schemes, palettes, and dyeing basics",
      "Surface Ornamentation Techniques: Hand and machine embroidery",
      "Printing methods: block printing, screen printing, digital printing",
      "Digital Textile Design: Using software like Adobe Illustrator and Photoshop",
      "Creating repeat patterns and motifs",
      "Preparing designs for production",
      "Fashion & Interior Applications: Designing for apparel and home décor",
    ],
  },
  "Digital Embroidery": {
    category: "Fashion & Textile Arts",
    description:
      "Master digital embroidery techniques using computerized machines and design software to create stunning patterns for fashion and home décor.",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    image: DigitalEmbroidery,
    aboutCourse: `Unleash your creativity with our Digital Embroidery Course, designed to teach you the art and technology behind modern embroidery using computerized machines and design software. Learn how to create stunning, professional-quality embroidery patterns for fashion, home décor, and personalized gifts.

This course allows you to learn at your own pace while gaining hands-on skills in digital embroidery design, machine operation, and troubleshooting, preparing you to turn your passion into a rewarding career or business.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior embroidery experience required",
      "Interest in textile arts and design",
      "Creative mindset and attention to detail",
    ],
    materialIncludes: [
      "Complete digital embroidery training",
      "Embroidery design software tutorials",
      "Machine operation guides",
      "Design techniques and patterns",
      "Project-based learning materials",
      "Business setup guidance",
    ],
    whoCanJoin: [
      "Beginners: No prior embroidery or design experience needed",
      "Fashion Designers & Tailors: Wanting to add embroidery to their skillset",
      "Hobbyists & Crafters: Interested in digital embroidery techniques",
      "Entrepreneurs: Planning to start an embroidery business",
      "Art & Textile Students: Looking to enhance their creative portfolio",
      "Anyone passionate about combining creativity with technology",
    ],
    whatWillYouLearn: [
      "Introduction to Digital Embroidery: Basics of embroidery and its applications",
      "Overview of digital embroidery machines and software",
      "Embroidery Design Software: Using popular software like Wilcom, Brother PE-Design",
      "Creating and editing embroidery patterns",
      "Converting artwork into embroidery files",
      "Machine Operation: Setting up and operating computerized embroidery machines",
      "Threading, hooping, and fabric preparation",
      "Troubleshooting common machine issues",
      "Design Techniques: Stitch types and their uses",
      "Color management and layering",
    ],
  },
//   "CGI Ads": {
//     category: "Digital Arts & Advertising",
//     description:
//       "Create captivating computer-generated imagery for advertising with professional CGI techniques and industry-standard software.",
//     duration: "4 Months",
//     level: "Beginner to Advanced",
//     image: CGIAds,
//     aboutCourse: `Step into the world of stunning visual effects and digital creativity with our CGI Ads Course. Learn how to create captivating computer-generated imagery (CGI) for advertising that grabs attention and elevates brand storytelling. This course covers the essential tools and techniques used in the production of high-quality CGI ads, combining creativity with technical expertise.

// In this course, you can learn at your own pace and practice with hands-on projects, mastering everything from 3D modeling and animation to rendering and compositing for commercials, social media, and marketing campaigns.`,
//     requirements: [
//       "Basic computer and internet skills",
//       "A laptop or desktop with internet access",
//       "No prior CGI experience required",
//       "Creative mindset and visual storytelling skills",
//       "Interest in digital arts and advertising",
//     ],
//     materialIncludes: [
//       "Complete CGI production training",
//       "3D modeling and animation software",
//       "Rendering and compositing tools",
//       "Project files and templates",
//       "Industry-standard software access",
//       "Portfolio development resources",
//     ],
//     whoCanJoin: [
//       "Students: Interested in digital arts, animation, or advertising",
//       "Beginners: No prior CGI or animation experience required",
//       "Graphic Designers & Animators: Wanting to expand into CGI production",
//       "Marketing Professionals: Who want to create eye-catching ads",
//       "Freelancers & Content Creators: Looking to offer CGI ad services",
//       "Anyone passionate about blending art and technology to create impactful ads",
//     ],
//     whatWillYouLearn: [
//       "CGI Basics: Introduction to CGI and its role in advertising",
//       "Overview of CGI production pipeline",
//       "3D Modeling & Texturing: Creating realistic 3D models for ads",
//       "Applying textures and materials",
//       "Animation Techniques: Keyframe animation and motion graphics",
//       "Animating objects, cameras, and lighting",
//       "Rendering & Compositing: Rendering high-quality visuals",
//       "Compositing CGI with live-action footage",
//       "Software Mastery: Working with industry-standard tools like Blender, Cinema 4D",
//       "Using Adobe After Effects for compositing and effects",
//     ],
//   },
  "Cross platform Flutter App Development": {
    category: "Mobile App Development",
    description:
      "Build beautiful, high-performance mobile applications for both Android and iOS using Flutter's single codebase approach.",
    duration: "5 Months",
    level: "Beginner to Advanced",
    image: FlutterDev,
    aboutCourse: `Learn how to build beautiful, high-performance mobile applications that run seamlessly on both Android and iOS platforms with our Cross-Platform Flutter App Development Course. Flutter, developed by Google, is an open-source UI toolkit that enables fast development with a single codebase.

This course guides you step-by-step from beginner fundamentals to advanced Flutter concepts. Master Flutter widgets, state management, API integration, and app deployment to become a confident app developer ready for the modern mobile landscape.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior programming experience required",
      "Interest in mobile app development",
      "Willingness to learn new technologies",
    ],
    materialIncludes: [
      "Complete Flutter development training",
      "Dart programming language tutorials",
      "Mobile app development tools",
      "API integration guides",
      "App deployment tutorials",
      "Project-based learning materials",
    ],
    whoCanJoin: [
      "Beginners: New to programming or app development",
      "Developers: Looking to expand skills into mobile app development",
      "Web Developers: Interested in building mobile apps using a single codebase",
      "Freelancers: Wanting to offer cross-platform app development services",
      "Entrepreneurs: Planning to create apps for their startups or businesses",
      "Anyone passionate about building sleek, responsive mobile apps",
    ],
    whatWillYouLearn: [
      "Flutter Basics: Installing and setting up Flutter SDK",
      "Understanding widgets and Flutter architecture",
      "Building simple user interfaces",
      "Dart Programming Language: Core concepts of Dart language",
      "Variables, functions, and object-oriented programming",
      "Asynchronous programming with Futures and Streams",
      "Advanced Flutter Concepts: State management techniques (Provider, Bloc)",
      "Working with animations and gestures",
      "Navigations and routing",
      "API Integration & Data Handling: Fetching and displaying data from REST APIs",
    ],
  },
  "Forex Trading": {
    category: "Finance & Trading",
    description:
      "Master currency trading fundamentals and advanced strategies to trade successfully in the global foreign exchange market.",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    image: ForexTrading,
    aboutCourse: `Unlock the world of currency trading with our comprehensive Forex Trading Course. This course is designed to teach you the fundamentals and advanced strategies to trade currencies successfully in the global foreign exchange market. Learn how to analyze market trends, manage risks, and execute profitable trades with confidence.

This course allows you to learn at your own pace and gain practical skills that can help you become a knowledgeable and disciplined forex trader.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior trading experience required",
      "Interest in financial markets",
      "Discipline and risk management mindset",
    ],
    materialIncludes: [
      "Complete forex trading training",
      "Trading platform tutorials",
      "Technical and fundamental analysis tools",
      "Risk management strategies",
      "Trading psychology guidance",
      "Practice account setup",
    ],
    whoCanJoin: [
      "Beginners: No prior trading experience needed; start from scratch",
      "Aspiring Traders: Looking to enter the forex market professionally",
      "Investors: Wanting to diversify portfolios with currency trading",
      "Freelancers: Interested in trading as a source of income",
      "Financial Enthusiasts: Who want to understand the mechanics of forex trading",
      "Anyone motivated to learn how to trade currencies effectively",
    ],
    whatWillYouLearn: [
      "Forex Market Basics: Understanding how the forex market works",
      "Currency pairs and how they are quoted",
      "Market participants and trading sessions",
      "Technical Analysis: Chart reading and candlestick patterns",
      "Support and resistance levels",
      "Indicators like Moving Averages, RSI, MACD",
      "Fundamental Analysis: Economic indicators and their impact on currency prices",
      "News trading strategies",
      "Central banks and monetary policies",
      "Trading Strategies: Day trading, swing trading, and scalping",
    ],
  },
  "Penetration Testing Web Hacking": {
    category: "Cybersecurity & Ethical Hacking",
    description:
      "Learn to identify, analyze, and exploit vulnerabilities in web hosting environments through ethical penetration testing.",
    duration: "4 Months",
    level: "Intermediate to Advanced",
    image: PenetrationTesting,
    aboutCourse: `The Penetration Testing for Web Hosting Course is designed to equip you with the essential skills to identify, analyze, and exploit vulnerabilities in web hosting environments. Learn how to assess the security posture of websites and servers to protect against cyber threats and attacks.

This course provides practical knowledge and hands-on experience in penetration testing methodologies specifically focused on web hosting infrastructure. Whether you want to work as a security professional or enhance your cybersecurity skills, this course will prepare you to detect and mitigate risks effectively.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "Basic understanding of networking concepts",
      "Interest in cybersecurity and ethical hacking",
      "Willingness to learn security tools and techniques",
    ],
    materialIncludes: [
      "Complete penetration testing training",
      "Security tools and software access",
      "Practice environments and labs",
      "Vulnerability assessment guides",
      "Reporting and documentation templates",
      "Career guidance and certification prep",
    ],
    whoCanJoin: [
      "Students: Interested in cybersecurity and ethical hacking",
      "Beginners: No prior penetration testing experience required; basics included",
      "IT Professionals: Looking to specialize in web hosting security",
      "Network Administrators: Wanting to strengthen server security",
      "Freelancers: Planning to offer penetration testing services",
      "Business Owners: Who want to understand and improve their web hosting security",
    ],
    whatWillYouLearn: [
      "Introduction to Penetration Testing: Fundamentals of ethical hacking and penetration testing",
      "Legal and ethical considerations",
      "Web Hosting Environment Overview: Understanding web hosting architectures",
      "Common hosting platforms and control panels (cPanel, Plesk)",
      "Reconnaissance & Information Gathering: Techniques to gather information about the hosting environment",
      "Tools for scanning and enumeration",
      "Vulnerability Assessment: Identifying common vulnerabilities in web hosting",
      "Exploiting misconfigurations and weak points",
      "Penetration Testing Tools & Techniques: Using tools like Nmap, Metasploit, Burp Suite",
      "Manual testing techniques",
    ],
  },
  "Advanced Google Ads": {
    category: "Digital Marketing & Advertising",
    description:
      "Master Google Ads platform to create, manage, and optimize paid advertising campaigns that deliver real results.",
    duration: "3 Months",
    level: "Intermediate to Advanced",
    image: AdvancedGoogleAds,
    aboutCourse: `The Google Ads Course is designed to teach you how to create, manage, and optimize paid advertising campaigns on Google's powerful advertising platform. Whether you want to promote your own business, work as a digital marketer, or offer freelance advertising services, this course will equip you with the skills to run effective Google Ads campaigns that deliver real results.

This course allows you to learn at your own pace and apply practical techniques that increase visibility, traffic, and conversions through Google Search, Display, YouTube, and more.`,
    requirements: [
      "Basic computer and internet skills",
      "A laptop or desktop with internet access",
      "No prior Google Ads experience required",
      "Interest in digital marketing and advertising",
      "Willingness to learn new advertising platforms",
    ],
    materialIncludes: [
      "Complete Google Ads training",
      "Campaign setup and optimization guides",
      "Keyword research tools and techniques",
      "Analytics and reporting tutorials",
      "Advanced targeting strategies",
      "Portfolio development resources",
    ],
    whoCanJoin: [
      "Students: Interested in digital marketing and advertising",
      "Beginners: No prior experience with Google Ads required",
      "Business Owners: Wanting to promote their products or services online",
      "Freelancers: Planning to offer Google Ads management services",
      "Marketing Professionals: Aiming to upgrade their advertising skills",
      "Anyone: Looking to generate leads and sales through paid ads",
    ],
    whatWillYouLearn: [
      "Google Ads Basics: Understanding Google Ads and its ecosystem",
      "Types of Google Ads campaigns (Search, Display, Video, Shopping)",
      "Setting up a Google Ads account",
      "Keyword Research & Campaign Setup: Finding the right keywords for your ads",
      "Creating targeted ad groups and campaigns",
      "Writing effective ad copy",
      "Bidding & Budget Management: Understanding bidding strategies",
      "Setting daily budgets and bid adjustments",
      "Optimizing cost per click (CPC) and return on ad spend (ROAS)",
      "Ad Extensions & Targeting: Using ad extensions to improve ad visibility",
    ],
  },
  "Search Engine Optimization - SEO": {
    category: "Digital Marketing & SEO",
    description:
      "Master SEO techniques to improve website visibility and drive organic traffic from search engines like Google.",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    image: SEO,
    aboutCourse: `The Search Engine Optimization (SEO) Course is designed to equip you with the essential skills to improve website visibility and drive organic traffic from search engines like Google. SEO is a vital digital marketing skill that helps businesses rank higher, attract more visitors, and increase conversions without paid advertising.

This course provides practical techniques and strategies you can apply to any website. Learn how search engines work, keyword research, on-page and off-page optimization, and the latest SEO best practices to boost your website's performance.`,
    requirements: [
      "Professional thumbnail design templates.",
      "SEO checklist for videos.",
      "Monetization roadmap and strategies.",
      "Video editing software tips & resources.",
      "Growth hacks to boost subscribers and watch hours.",
    ],
    materialIncludes: [
      "Complete SEO fundamentals training",
      "Keyword research tools and techniques",
      "Technical SEO guides",
      "Content optimization strategies",
      "Analytics and reporting tools",
      "Portfolio development resources",
    ],
    whoCanJoin: [
      "Students: Looking to enter the digital marketing field",
      "Beginners: No prior SEO knowledge required",
      "Website Owners & Bloggers: Wanting to increase organic traffic",
      "Digital Marketers: Aiming to enhance their SEO skills",
      "Freelancers: Planning to offer SEO services",
      "Business Owners: Who want to improve their website rankings and sales",
    ],
    whatWillYouLearn: [
      "SEO Fundamentals: How search engines work",
      "Understanding SEO ranking factors",
      "White-hat vs black-hat SEO techniques",
      "Keyword Research & Analysis: Finding high-impact keywords",
      "Using keyword research tools",
      "Competitor analysis",
      "On-Page SEO: Optimizing titles, meta descriptions, and headers",
      "URL structure and internal linking",
      "Image optimization and page speed",
      "Off-Page SEO: Link building strategies",
    ],
  },
  "YouTube Monetization": {
    category: "Digital Marketing & YouTube",
    description:
      "Master YouTube monetization techniques to earn money from your videos.",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    image: YouTubeMonetization,
    aboutCourse: `The YouTube Monetization & Growth Course is designed to teach you how to build, grow, and monetize your YouTube channel. From creating engaging videos to understanding YouTube’s algorithm, this course gives you all the tools and strategies to earn through YouTube. Whether you want to create content for fun, grow your brand, or start a career as a YouTuber, this course covers everything step-by-step.`,
    requirements: [
      "Basic knowledge of using a computer or smartphone.",
      "Laptop or smartphone with a camera (for video creation).",
      "Internet connection.",
      "No prior YouTube experience required.",
      "YouTube channel setup guide.",
    ],
    materialIncludes: [
      "Professional thumbnail design templates.",
      "SEO checklist for videos.",
      "Monetization roadmap and strategies.",
      "Video editing software tips & resources.",
      "Growth hacks to boost subscribers and watch hours.",
    ],
    whoCanJoin: [
      "Students:  Looking to build a career or side income through YouTube.",
      "Content Creators & Influencers: Who want to grow their audience and monetize content.",
      "Small Business Owners: Wanting to promote products and services on YouTube.",
      "Freelancers & Marketers: Offering YouTube content and channel management as services.",
      "Beginners: No prior video editing or YouTube experience is required.",
    ],
    whatWillYouLearn: [
      "YouTube Basics: How YouTube works & how to set up your channel.",
      "Content Strategy: How to find trending topics and plan viral content.",
      "Video SEO: Optimizing titles, tags, descriptions & thumbnails.",
      "Audience Growth: Tips to increase subscribers and watch time.",
      "YouTube Monetization: How to join the YouTube Partner Program.",
      "Earning Methods: Ad revenue, brand sponsorships, affiliate marketing, and merchandise.",
      "Video Editing: Step-by-step guide to creating professional videos.",
      "Analytics & Insights: Using YouTube Studio to track performance.",
    ],
  },
};
